export default __webpack_public_path__ + "52466729b536730f9ef62841a33f86c6.png";